var echarts = null
export default {
  echarts,
  setEcharts: function (ec) {
    this.echarts = ec
  },
  getOption1: function (scaleData) {
    var legend = []
    for (var l = 0; l < scaleData.length; l++) {
      legend.push(scaleData[l].name)
    }
    var rich = {
      white: {
        color: '#fff',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#ff5858', '#006ced', '#ffe000']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 0,
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [70, 75],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return '{white|' + '' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 20,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      color: color,
      tooltip: {
        show: false
      },
      legend: {
        data: legend,
        color: 'red',
        show: true,
        icon: 'circle',
        orient: 'vertical',
        left: '3%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      title: {
        text: '电梯梯龄分布',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption2: function (scaleData) {
    var legend = []
    for (var l = 0; l < scaleData.length; l++) {
      legend.push(scaleData[l].name)
    }
    var rich = {
      white: {
        color: '#ddd',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000', '#ff5858', '#006ced', '#ffe000']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 0,
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [70, 75],
      center: ['50%', '54%'],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return '\n{white|' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 10,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      color: color,
      tooltip: {
        show: true
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      legend: {
        data: legend,
        show: true,
        icon: 'circle',
        orient: 'vertical',
        left: '3%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      title: {
        text: '电梯品牌分布',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption3: function (x, s1) {
    var option = {
      color: ['#4691CE', '#ffba55', '#D14646'],
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['电梯总数', '终端数'],
        show: false,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 10
        }
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: x,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 0,
            margin: 8,
            rotate: -40,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 40,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          splitLine: { // 分隔线
            show: false, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              'color': '#5295CB'
            }
          }
        }
      ],
      series: [
        {
          name: '终端数',
          type: 'bar',
          data: s1
        }
      ],
      itemStyle: {
        normal: {
          barBorderRadius: 5
        },
        emphasis: {
          barBorderRadius: 0
        }
      }
    }
    return option
  },
  getOption4: function (data) {
    let color = ['#FE5050', '#FBFE27', '#1DB7E5']
    let data1 = data[0].value + data[1].value + data[2].value
    let baseData = []
    for (var i = 0; i < data.length; i++) {
      baseData.push({
        value: data[i].value,
        name: data[i].name,
        itemStyle: {
          normal: {
            borderWidth: 22,
            shadowBlur: 50,
            borderColor: color[i],
            shadowColor: 'rgba(0, 0, 0, 0.8)'
          }
        }
      })
    }
    var option = {
      backgroundColor: '#2c343c',
      color: color,
      tooltip: {
        show: true,
        trigger: 'item',
        formatter: '{a}：{b} <br/>占比：{d}%'
      },
      legend: {
        data: ['人工报警', '异常提醒', '投诉建议'],
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      grid: {
        top: 'bottom',
        left: '90',
        width: '90%',
        height: '80%'

      },
      series: [{
        zlevel: 1,
        name: '数据采集',
        type: 'pie',
        selectedMode: 'single',
        radius: [95, 98],
        startAngle: '135',
        hoverAnimation: false,
        label: {
          normal: {
            show: true,
            formatter: ['{b|{b}}', '{c|{c}}'].join('\n'),
            rich: {
              b: {
                fontSize: 12,
                lineHeight: 16
              }

            },
            labelLine: {
              length: 2,
              length2: 2,
              show: true,
              color: '#00ffff'
            }
          }
        },
        itemStyle: {
          normal: {
            shadowColor: 'rgba(0, 0, 0, 0.8)',
            shadowBlur: 40,
            labelLine: {
              length: 20,
              length2: 5,
              show: true,
              color: '#00ffff'
            }
          }
        },
        data: baseData
      },
      {
        name: '',
        type: 'pie',
        selectedMode: 'single',
        radius: [95, 100],
        startAngle: '195',
        data: [{
          'value': data1,
          'name': '',
          'label': {
            'normal': {
              'show': true,
              'formatter': '{c|{c}} {b|条} \n {a|累计事件}',
              rich: {
                c: {
                  color: '#FBFE27',
                  fontSize: 20,
                  fontWeight: 'bold',
                  lineHeight: 10
                },
                b: {
                  color: '#FBFE27',
                  fontSize: 20,
                  lineHeight: 10
                },
                a: {
                  align: 'center',
                  color: 'rgb(98,137,169)',
                  fontSize: 12,
                  height: 20
                }
              },
              'textStyle': {
                'fontSize': 16,
                'fontWeight': 'bold'
              },
              'position': 'center'

            }
          }
        }]
      }
      ]
    }
    return option
  },
  getOption5: function (scaleData) {
    var legend = []
    for (var l = 0; l < scaleData.length; l++) {
      legend.push(scaleData[l].name)
    }
    var rich = {
      white: {
        color: '#ddd',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 2,
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [70, 75],
      center: ['50%', '54%'],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return '\n{white|' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 20,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      color: color,
      tooltip: {
        show: false
      },
      legend: {
        data: legend,
        show: true,
        icon: 'circle',
        orient: 'vertical',
        left: '3%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      title: {
        text: '故障类型分布',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption6: function (scaleData) {
    var legend = []
    for (var l = 0; l < scaleData.length; l++) {
      legend.push(scaleData[l].name)
    }
    var rich = {
      white: {
        color: '#ddd',
        align: 'center',
        padding: [3, 0]
      }
    }
    var placeHolderStyle = {
      normal: {
        label: {
          show: false
        },
        labelLine: {
          show: false
        },
        color: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0
      }
    }
    var data = []
    var color = ['#00ffff', '#ff5858', '#006ced', '#ffe000', '#ffa800', '#ff5b00', '#ff3000']
    for (var i = 0; i < scaleData.length; i++) {
      data.push({
        value: scaleData[i].value,
        name: scaleData[i].name,
        itemStyle: {
          normal: {
            borderWidth: 8,
            shadowBlur: 5,
            borderColor: color[i],
            shadowColor: color[i]
          }
        }
      }, {
        value: 2,
        name: '',
        itemStyle: placeHolderStyle
      })
    }
    var seriesObj = [{
      name: '',
      type: 'pie',
      clockWise: false,
      radius: [70, 75],
      hoverAnimation: false,
      itemStyle: {
        normal: {
          label: {
            show: true,
            position: 'outside',
            color: '#ddd',
            formatter: function (params) {
              var percent = 0
              var total = 0
              for (var i = 0; i < scaleData.length; i++) {
                total += scaleData[i].value
              }
              percent = ((params.value / total) * 100).toFixed(2)
              if (params.name !== '') {
                return '\n{white|' + '' + percent + '%}'
              } else {
                return ''
              }
            },
            rich: rich
          },
          labelLine: {
            length: 20,
            length2: 10,
            show: true,
            color: '#00ffff'
          }
        }
      },
      data: data
    }]
    var option = {
      color: color,
      tooltip: {
        show: false
      },
      legend: {
        data: legend,
        show: true,
        icon: 'circle',
        orient: 'vertical',
        left: '3%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      toolbox: {
        show: false
      },
      title: {
        text: '故障原因分布',
        left: 'center',
        top: '38%',
        padding: [24, 0],
        textStyle: {
          color: '#fff',
          fontSize: 18,
          align: 'center'
        }
      },
      series: seriesObj
    }
    return option
  },
  getOption7: function (s1, s2) {
    var option = {
      color: ['#5295CB', '#FF6666', '#FFCA6C'],
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['维保', '年检'],
        show: true,
        icon: 'circle',
        top: '2%',
        textStyle: {
          color: '#FFF',
          fontSize: 14
        }
      },
      grid: {
        left: '5%',
        right: '5%',
        bottom: '10%',
        top: '12%',
        containLabel: true
      },
      toolbox: {
        show: false
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          boundaryGap: false,
          data: s1,
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            interval: 0,
            rotate: 40,
            margin: 8,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            textStyle: {
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: false
          },
          lineStyle: {
            color: '#5295CB'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { // 坐标轴文本标签，详见axis.axisLabel
            show: true,
            rotate: 0,
            margin: 8,
            // formatter: null,
            textStyle: { // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#FFF'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              'color': '#5295CB'
            }
          },
          splitLine: { // 分隔线
            show: true, // 默认显示，属性show控制显示与否
            lineStyle: { // 属性lineStyle（详见lineStyle）控制线条样式
              color: ['#5295CB'],
              width: 1,
              type: 'dashed'
            }
          }
        }
      ],
      series: [
        {
          name: '故障数量',
          type: 'line',
          smooth: true,
          itemStyle: {
            color: 'rgb(255, 70, 131)',
            normal: {
              areaStyle: {
                color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgb(94, 228, 225)'
                }, {
                  offset: 1,
                  color: 'rgb(15, 26, 79)'
                }])
              },
              lineStyle: { // 系列级个性化折线样式
                width: 2,
                type: 'solid',
                color: 'rgb(94, 228, 225' // 折线的颜色
              }
            }
          },
          data: s2,
          symbol: 'none',
          sampling: 'average'
        }
      ]
    }
    return option
  },
  randomNum: function (minNum, maxNum) {
    switch (arguments.length) {
      case 1:
        return parseInt(Math.random() * minNum + 1, 10)
      case 2:
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      default:
        return 0
    }
  },
  chartsMap: function (cityName, data) {
    // 首页地图圆圈显示位置
    var geoCoordMap = this.mapCenterData()
    var mapData = []
    for (var key in geoCoordMap) {
      mapData.push({ 'name': key, 'value': this.randomNum(100, 300) })
    }
    var convertData = function (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            id: data[i].id,
            name: data[i].name,
            value: geoCoord,
            itemSize: data[i].itemSize,
            totalSize: data[i].totalSize,
            isAlert: data[i].isAlert
          })
        }
      }
      return res
    }
    var option = {
      backgroundColor: '#0b133F',
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          if (params.value.length === 2) { //通过圆点点击
            return params.name + ' : ' + params.data.itemSize
          } else {
            if (params.value) {
              return params.name + ' : ' + params.value
            } else {
              return params.name + ' '
            }
          }
        }
      },
      toolbox: {
        show: false
      },
      geo: {
        show: true,
        map: cityName,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          emphasis: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        roam: true,

        itemStyle: {
          normal: {
            borderColor: 'rgba(147, 235, 248, 1)',
            borderWidth: 1,
            areaColor: {
              type: 'radial',
              x: 0.5,
              y: 0.5,
              r: 0.8,
              colorStops: [{
                offset: 0,
                color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
              }, {
                offset: 1,
                color: 'rgba(147, 235, 248, .2)' // 100% 处的颜色
              }],
              globalCoord: false // 缺省为 false
            },
            shadowColor: 'rgba(128, 217, 248, 1)',
            // shadowColor: 'rgba(255, 255, 255, 1)',
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10
          },
          emphasis: {
            areaColor: '#389BB7',
            borderWidth: 0
          }
        }
      },
      series: [{
        data: convertData(data),
        type: 'effectScatter',
        coordinateSystem: 'geo',
        // symbol: 'diamond',
        showEffectOn: 'render',
        rippleEffect: {
          period: 12,
          scale: 6,
          brushType: 'fill'
        },
        hoverAnimation: true,
        itemStyle: {
          normal: {
            color: function (params) {
              if (params.data.isAlert === 1) {
                return 'rgba(228, 90, 92, 1)'
              } else {
                return 'rgba(38, 127, 234, 1)'
              }
            },
            shadowBlur: 90,
            shadowColor: '#333'
          }
        },
        label: {
          normal: {
            show: true,
            position: 'inside',
            formatter: function (params) {
              return params.data.itemSize
            },
            textStyle: {
              color: '#fff'
            }
          }
        }
      }, {
        type: 'map',
        map: '郴州市',
        geoIndex: 0,
        aspectScale: 0.75,
        showLegendSymbol: false,
        label: {
          normal: {
            show: false
          },
          emphasis: {
            show: false,
            textStyle: {
              color: '#fff'
            }
          }
        },
        roam: true,
        itemStyle: {
          normal: {
            areaColor: '#031525',
            borderColor: '#3B5077'
          },
          emphasis: {
            areaColor: '#2B91B7'
          }
        },
        animation: false,
        data: data
      }
      ]
    }
    return option
  },

  mapCenterData: function () {
    //区县地图 网关数量显示位置
    var geoCoordMap = []
    geoCoordMap['永兴县'] = [113.126559, 26.138418]
    geoCoordMap['苏仙区'] = [113.08292, 25.874115]
    geoCoordMap['资兴市'] = [113.401234, 26.056421]
    geoCoordMap['北湖区'] = [112.897824, 25.692379]
    geoCoordMap['安仁县'] = [113.271977, 26.730914]
    geoCoordMap['桂阳县'] = [112.658344, 25.821455]
    geoCoordMap['永兴县'] = [113.12081, 26.126482]
    geoCoordMap['宜章县'] = [112.942254, 25.403363]
    geoCoordMap['嘉禾县'] = [112.379035, 25.58534]
    geoCoordMap['临武县'] = [112.573284, 25.276516]
    geoCoordMap['汝城县'] = [113.692699, 25.551623]
    geoCoordMap['桂东县'] = [113.948141, 26.077204]
    geoCoordMap['颍州区'] = [115.813914, 32.891238]
    geoCoordMap['颍东区'] = [115.858747, 32.908861]
    geoCoordMap['颍泉区'] = [115.804525, 32.924797]
    geoCoordMap['临泉县'] = [115.261688, 33.062698]
    geoCoordMap['太和县'] = [115.627243, 33.16229]
    geoCoordMap['阜南县'] = [115.590534, 32.638102]
    geoCoordMap['颍上县'] = [116.259122, 32.637065]
    geoCoordMap['界首市'] = [115.362117, 33.26153]
    geoCoordMap['连州市'] = [112.45333, 24.931769]
    geoCoordMap['连南瑶族自治县'] = [112.261692, 24.558638]
    geoCoordMap['连山壮族瑶族自治县'] = [112.086555, 24.567271]
    geoCoordMap['阳山县'] = [112.675689, 24.503911]
    geoCoordMap['英德市'] = [113.318007, 24.220066]
    geoCoordMap['清新区'] = [112.82901, 23.907724]
    geoCoordMap['清城区'] = [113.136997, 23.671751]
    geoCoordMap['清新县'] = [112.82901, 23.907724]
    geoCoordMap['佛冈县'] = [113.559595, 23.877102]
    geoCoordMap['双清区'] = [111.546436, 27.241775]
    geoCoordMap['大祥区'] = [111.485515, 27.159475]
    geoCoordMap['北塔区'] = [111.420079, 27.248192]
    geoCoordMap['邵东县'] = [111.850315, 27.187043]
    geoCoordMap['新邵县'] = [111.464609, 27.42558]
    geoCoordMap['邵阳县'] = [111.325512, 26.979422]
    geoCoordMap['隆回县'] = [110.965394, 27.346434]
    geoCoordMap['洞口县'] = [110.591412, 27.098117]
    geoCoordMap['绥宁县'] = [110.199275, 26.707518]
    geoCoordMap['新宁县'] = [110.917809, 26.541408]
    geoCoordMap['城步苗族自治县'] = [110.318488, 26.318776]
    geoCoordMap['武冈市'] = [110.739526, 26.781927]
    geoCoordMap['江津区'] = [106.313604,29.430387]
    geoCoordMap['邵阳市'] = [113.126559, 26.138418]
    geoCoordMap['郴州市'] = [110.965394, 27.346434]

    geoCoordMap['十堰市'] = [110.805391,32.634759]
    geoCoordMap['丹江口市'] = [111.520296,32.546349]
    geoCoordMap['茅箭区'] = [110.820133,32.598078]
    geoCoordMap['张湾区'] = [110.775833,32.658471]
    geoCoordMap['郧阳区'] = [110.819865,32.841211]
    geoCoordMap['竹山县'] = [110.235625,32.230524]
    geoCoordMap['竹溪县'] = [109.721864,32.324188]
    geoCoordMap['房县'] = [110.733545,32.046904]

    geoCoordMap['玉林市'] = [110.187436,22.660151]
    geoCoordMap['玉州区'] = [110.157118,22.634743]
    geoCoordMap['容县'] = [110.564374,22.863748]
    geoCoordMap['陆川县'] = [110.270583,22.327554]
    geoCoordMap['博白县'] = [109.982674,22.278998]
    geoCoordMap['兴业县'] = [109.881778,22.742171]
    geoCoordMap['北流市'] = [110.360647,22.713906]
    geoCoordMap['福绵区'] = [110.066051,22.591486]
    


    geoCoordMap['北京市'] = [116.417411,39.920885]
    geoCoordMap['河北省'] = [114.513597,38.042973]
    geoCoordMap['江苏省'] = [118.814971,32.097371]
    geoCoordMap['浙江省'] = [120.208405,30.285272]
    geoCoordMap['安徽省'] = [117.231654,31.841105]
    geoCoordMap['福建省'] = [119.336366,26.128919]
    geoCoordMap['江西省'] = [115.861379,28.711853]
    geoCoordMap['山东省'] = [117.138401,36.686666]
    geoCoordMap['河南省'] = [113.668543,34.766731]
    geoCoordMap['湖北省'] = [114.298425,30.614029]
    geoCoordMap['湖南省'] = [112.995353,28.21686]
    geoCoordMap['广东省'] = [113.283924,23.156824]
    // geoCoordMap['广西藏族自治区'] = [110.312831,22.653256]
    geoCoordMap['四川省'] = [104.090136,30.592218]
    geoCoordMap['云南省'] = [102.848651,24.906136]
    geoCoordMap['陕西省'] = [108.970163,34.337592]
    geoCoordMap['香港'] = [114.199348,22.327022]
    return geoCoordMap
  }
}



// WEBPACK FOOTER //
// ./src/api/charts_view4.js